// @flow
import React, { type Node } from 'react';

import StaticTextField from './StaticTextField';
import LabeledField from './LabeledField';

type Props = {
  children?: Node,
  label: string,
  labelClassName?: string,
  readonly?: boolean,
  value?: string,
  dataTestName?: string,
};

export default function FormField({
  children,
  label,
  labelClassName,
  readonly,
  value,
  dataTestName,
}: Props) {
  // if static, use label class name for value too
  if (readonly) {
    return (
      <StaticTextField
        label={label}
        labelClassName={labelClassName}
        value={value}
        valueClassName={labelClassName}
        data-test-name={dataTestName || 'field'}
      />
    );
  } else {
    return (
      <LabeledField label={label} labelClassName={labelClassName}>
        {children}
      </LabeledField>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/Forms/FormField.js